module.exports = __webpack_public_path__ + "media/theme/status wait-efaec051.svg";